module.exports = __webpack_public_path__ + "humanResourcesHeaderBg.f2e87ec739ec7d51fe18.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/humanResourcesHeaderBg.jpg
// module id = ../../../../../src/assets/img/humanResourcesHeaderBg.jpg
// module chunks = main